import { formatSpeed } from '../format.js';
import { type PlayerController } from '../player/controller.js';
import { SPEED_OPTIONS } from '../config.js';
import { isAtLatest, playing, speed } from '../state/store.js';

type Props = {
  player: PlayerController;
};

export const Controls = ({ player }: Props) => (
  <div class="controls">
    <button type="button" class="controls__button" onClick={() => player.prev()} aria-label="Imagen anterior">⏮</button>
    <button
      type="button"
      class="controls__button controls__button--primary"
      onClick={() => player.toggle()}
      aria-label={playing.value ? 'Pausar' : 'Reproducir'}
    >
      {playing.value ? '⏸' : '▶'}
    </button>
    <button type="button" class="controls__button" onClick={() => player.next()} aria-label="Imagen siguiente">⏭</button>
    <button
      type="button"
      class="controls__button"
      onClick={() => player.last()}
      disabled={isAtLatest.value}
      aria-label="Ir a la última imagen"
    >
      ⏭⏭
    </button>
    <div class="controls__speed" role="group" aria-label="Velocidad">
      {SPEED_OPTIONS.map(value => (
        <button
          key={value}
          type="button"
          class={`controls__chip${speed.value === value ? ' controls__chip--active' : ''}`}
          onClick={() => player.setSpeed(value)}
          aria-pressed={speed.value === value}
        >
          {formatSpeed(value)}
        </button>
      ))}
    </div>
  </div>
);
